var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Loader } from "./Loader/Loader";
export var Spinner = styled(Loader)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0;\n    right: 5px;\n    height: 1em;\n    &:before {\n        border-width: 1px;\n        width: 15px;\n        height: 15px;\n    }\n"], ["\n    position: absolute;\n    bottom: 0;\n    right: 5px;\n    height: 1em;\n    &:before {\n        border-width: 1px;\n        width: 15px;\n        height: 15px;\n    }\n"])));
var templateObject_1;
